import dynamic from 'next/dynamic'
export default dynamic(() => import('./_zoom-image'), { ssr: false })
